export default {
  sectionLineItems: [],
  sectionLineItem: undefined,
};
